import { createAction } from 'redux-act';
import { IModalStateChangeAction } from '../types/modals';

export const changeModalState = createAction<IModalStateChangeAction>('SET_MODAL_STATE');
